import React from 'react';
import styles from '../Markdown.pcss';

const MarkdownHeading = (props: {level: number; children: React.ReactNode}) => {
    const HeadingTag = `h${props.level}`;
    return <HeadingTag className={styles.heading}>{props.children}</HeadingTag>;
};

export default MarkdownHeading;
